import { render, staticRenderFns } from "./RecorderV2.vue?vue&type=template&id=0631f90b&scoped=true&"
import script from "./RecorderV2.vue?vue&type=script&lang=js&"
export * from "./RecorderV2.vue?vue&type=script&lang=js&"
import style0 from "./RecorderV2.vue?vue&type=style&index=0&id=0631f90b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0631f90b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
